import React, { useState, useEffect } from 'react';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

export interface FilterDialogDatamodel {
  rangeDates: boolean;
  visible: boolean;
  onHide: () => any;
  startDateDefaultValue: Date;
  endDateDefaultValue: Date;
  onFinish: (startDate: Date, endDate: Date) => any;
  title: string;
}

export const FilterDialog: React.FC<FilterDialogDatamodel> = ({
  rangeDates,
  visible,
  onHide,
  startDateDefaultValue,
  endDateDefaultValue,
  onFinish,
  title,
}) => {
  const [startDate, setStartDate] = useState<Date>(startDateDefaultValue);
  const [endDate, setEndDate] = useState<Date>(endDateDefaultValue);

  // Update local state when default values change
  useEffect(() => {
    setStartDate(startDateDefaultValue);
    setEndDate(endDateDefaultValue);
  }, [startDateDefaultValue, endDateDefaultValue]);

  const handleApply = () => {
    onFinish(startDate, endDate);
    onHide();
  };
  return (
    <Dialog
      header={title}
      visible={visible}
      style={{ width: '400px' }}
      onHide={() => onHide()}
      modal
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {rangeDates ? (
          <>
            <div>
              <label
                style={{
                  display: 'block',
                  marginBottom: '8px',
                  fontWeight: 'bold',
                }}
              >
                תאריך התחלה:
              </label>
              <Calendar
                value={startDate}
                onChange={(e) => setStartDate(e.value as Date)}
                dateFormat="dd/mm/yy"
                showIcon
                inputStyle={{ textAlign: 'right' }}
                style={{
                  direction: 'ltr',
                  width: '100%',
                  textAlign: 'right',
                }}
              />
            </div>
            <div>
              <label
                style={{
                  display: 'block',
                  marginBottom: '8px',
                  fontWeight: 'bold',
                }}
              >
                תאריך סיום:
              </label>
              <Calendar
                value={endDate}
                onChange={(e) => setEndDate(e.value as Date)}
                dateFormat="dd/mm/yy"
                showIcon
                inputStyle={{ textAlign: 'right' }}
                style={{
                  direction: 'ltr',
                  width: '100%',
                  textAlign: 'right',
                }}
              />
            </div>
          </>
        ) : (
          <div>
            <label
              style={{
                display: 'block',
                marginBottom: '8px',
                fontWeight: 'bold',
              }}
            >
              תאריך:
            </label>
            <Calendar
              value={startDate}
              onChange={(e) => setStartDate(e.value as Date)}
              dateFormat="dd/mm/yy"
              showIcon
              style={{ width: '100%' }}
            />
          </div>
        )}
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '8px',
            marginTop: '16px',
          }}
        >
          <Button label="ביטול" outlined onClick={() => onHide()} />
          <Button label="החל" onClick={handleApply} />
        </div>
      </div>
    </Dialog>
  );
};
